module.exports = __webpack_public_path__ + "static/img/five-years-on.02b0528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/five-years-on.png
// module id = KZcw
// module chunks = 0